enum ExpediteInviteRequestConstants {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  ONBOARDING_COMPLETED = 'ONBOARDING_COMPLETED',

  GET_INVITE_REQUESTS = '@ExpediteInviteRequests/GET_INVITE_REQUESTS',
  GET_INVITE_REQUESTS_REQUEST = '@ExpediteInviteRequests/GET_INVITE_REQUESTS_REQUEST',
  GET_INVITE_REQUESTS_REQUEST_SUCCESS = '@ExpediteInviteRequests/GET_INVITE_REQUESTS_REQUEST_SUCCESS',
  GET_INVITE_REQUESTS_REQUEST_ERROR = '@ExpediteInviteRequests/GET_INVITE_REQUESTS_REQUEST_ERROR',
}

export default ExpediteInviteRequestConstants;
